import React from 'react';
import styles from './ToeicHero.module.css';

const scores = [
  { num: '400→', label: 'Điểm đầu vào TB' },
  { num: '900+', label: 'Mục tiêu khả thi' },
  { num: '3–6', label: 'Tháng hoàn thành' },
];

/**
 * Hero section for the TOEIC page.
 */
function ToeicHero() {
  return (
    <div className={styles.hero} aria-label="TOEIC Hero">
      <div className={styles.badge}>TOEIC – Tiếng Anh Chuyên Nghiệp</div>
      <h1 className={styles.heading}>
        Từ người học đến người{' '}
        <em>dùng được tiếng Anh</em>
      </h1>
      <p className={styles.sub}>
        Khoá TOEIC tại Annie Class được thiết kế theo mô hình dual-track: song song phát triển
        language proficiency thực sự và tối ưu hoá chiến thuật làm bài — để bạn không chỉ đạt
        điểm số mục tiêu mà còn sở hữu năng lực tiếng Anh đủ để vận hành trong môi trường
        công việc quốc tế.
      </p>
      <div className={styles.scoreGrid} role="list" aria-label="Thống kê điểm">
        {scores.map((s) => (
          <div key={s.label} className={styles.scoreBox} role="listitem">
            <div className={styles.scoreNum}>{s.num}</div>
            <div className={styles.scoreLbl}>{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ToeicHero;
